<template>
    <v-container class="py-0"  ref="slider" >
        <v-row>
            <v-col class="pa-0">
                <v-range-slider
                        v-if="value"
                        :loading="loading"
                        background-color="awesome"
                        color="white"
                        track-fill-color="red"
                        dense
                        height="15"
                        v-model="value"
                        :max="max"
                        :min="min"
                        thumb-size="10"
                        thumb-label="always"
                        dark
                        @mousedown="Down($event)"
                        @mouseup="Up($event)"
                >
                    <template v-slot:thumb-label="{ value }">
                        <div class="slidelable">{{(value/10).toFixed(1)}}</div>
                    </template>
                    <template v-slot:prepend>
                        <v-btn text x-small @click="Nudge('start',-1)" class="pa-0">
                            <v-icon small>mdi-chevron-double-left</v-icon>
                        </v-btn>
                        <v-btn text x-small class="pa-0" disabled>
                            <span class="white--text">{{ (value[0]/10).toFixed(1) }}</span>
                        </v-btn>
                        <v-btn text x-small @click="Nudge('start',1)" class="pa-0">
                            <v-icon small>mdi-chevron-double-right</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:append>
                        <v-btn text x-small @click="Nudge('end',-1)" class="pa-0">
                            <v-icon small>mdi-chevron-double-left</v-icon>
                        </v-btn>
                        <v-btn text x-small class="pa-0" disabled>
                            <span class="white--text">{{ (value[1]/10).toFixed(1) }}</span>
                        </v-btn>
                        <v-btn text x-small @click="Nudge('end',1)" class="pa-0">
                            <v-icon small>mdi-chevron-double-right</v-icon>
                        </v-btn>
                    </template>
                    <template v-slot:progress="{ value }">
                        <div :style="`width:${value}px;height:10px;background-color: rebeccapurple;`">d</div>
                    </template>

                </v-range-slider>
                <!--Push slide button here-->
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    name: "VideoRangeSlider",
    props:['start','end'],
    components: {},
    data() {
      return {
        dragging: false,
        left:10,
        mousemove: undefined,
        value: undefined,
        max: 300,
        min: 200,
        loading:false
      }
    },
    computed: {
      ...mapState([])
    },
    watch: {
      start(n){
        this.value = [n*10,this.end*10]
        this.Up()
      },
      end(n){
        this.value = [this.start*10,n*10]
        this.Up()
      }
    },
    mounted(){
      this.value = [this.start*10,this.end*10]
      this.Up()
    },
    methods: {
      ...mapActions(['get', 'post']),
      Nudge(v,val){
        //in 10ths of a second here!!
        if(v==='start'){
          this.value[0]+=val
        }
        if(v==='end'){
          this.value[1]+=val
        }
        this.Up()
      },
      Down(){},
      Up(e){
        this.loading=true;
        let spread = this.value[1] - this.value[0]
        if(spread<=10){
          spread=10
          this.value[1] = this.value[0]+10;
          this.min = parseInt(this.value[0] - spread)
          this.max = parseInt(this.value[1] + spread)
        } else {
          this.min = parseInt(this.value[0] - spread+10)
          this.max = parseInt(this.value[1] + spread-10)
        }
        this.min = (this.min<=0)?0:this.min
        this.max = (this.max>=this.duration)?this.duration:this.max
        this.$emit('update',this.value)
        this.$emit('cliplength',spread/10)
        this.loading=false;
      }
    }
  }

</script>

<style scoped>
    .slidelable{
        border: solid thin #333333;
        border-radius:3px;
        padding: 3px;
        background-color: white;
        color: #333333;
    }
    .wrapper{
        width:100%;
        height:22px;
        position: relative;
    }
    .barwrapper{
        height:100%;
        width:50%;
        position:absolute;
    }
    .leftbar{
        display: inline-block;
        border: solid thin #454545;
        height:100%;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        width:18px;
        background-color: #dddd21;
    }
    .leftbar:hover{
        cursor: pointer;
        background-color: #eeff41;
    }
    .rightbar{
        display: inline-block;
        border: solid thin #454545;
        height:100%;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        width:18px;
        background-color: #dddd21;
    }
    .rightbar:hover{
        cursor: pointer;
        background-color: yellow;
    }
    .widthbar{
        display: inline-block;
        height:50%;
        width:200px;
        background-color: orange;
    }
    .widthbar:hover{
        cursor: pointer;
        background-color: darkorange;
    }

</style>